/*
 * Image Simple
 *
 * Supports:
 * - Retina
 * - Lazy loading of full resolution src
 * - Webp src for suitable browsers
 */

import React, { useRef } from 'react';
import PropTypes from 'prop-types';

import { useLazyImage } from '$hooks/image.js';

const emptySrc = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNkYPhfDwAChwGA60e6kgAAAABJRU5ErkJggg==';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const ImageSimple = ({
    alt,
    className,
    psrc,
    px2,
    role,
    src,
    style,
    x2
}) => {
    const imageRef = useRef();

    const {
        imageSrc,
        imageX2,
        loaded
    } = useLazyImage({
        imageRef,
        src,
        psrc,
        x2,
        px2
    });

    return (
        <img
            alt={alt}
            className={className}
            ref={imageRef}
            role={role}
            src={imageSrc || emptySrc}
            srcSet={imageX2 ? `${imageX2} 2x` : null}
            style={{
                ...{
                    opacity: loaded ? 1 : 0,
                    transition: 'opacity .3s'
                },
                ...style
            }} />
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    alt: PropTypes.string,
    className: PropTypes.string,
    psrc: PropTypes.string,
    px2: PropTypes.string,
    role: PropTypes.string,
    src: PropTypes.string.isRequired,
    style: PropTypes.object,
    x2: PropTypes.string
};

ImageSimple.propTypes = propTypes;

export default ImageSimple;
